import React from "react";
import { useNavigate } from "react-router-dom";

const Error = () => {
  const navigate = useNavigate();

  const handleGoBack = () => {
    navigate(-1); // Navigate to the previous page
  };

  return (
    <div className="size-full p-6 xl:p-8 2xl:p-10">
      <h1 className="mb-4 text-2xl font-bold text-red-600">
        Something Went Wrong
      </h1>
      <p className="mb-6 text-gray-700">
        We're sorry, but something went wrong. Please try again later.
      </p>
      <button
        onClick={handleGoBack}
        className="rounded bg-blue-600 px-4 py-2 text-white hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-500"
      >
        Go Back
      </button>
    </div>
  );
};

export default Error;
